import { Component, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { takeWhile, finalize } from 'rxjs';

import { EntitiesService, IEntity } from '@app/core/entities';

@Component({
  selector: 'app-entity-dialog',
  templateUrl: './entity-dialog.component.html',
})
export class EntityDialogComponent implements OnDestroy {
  public form: FormGroup;
  public saving: boolean;

  private entity: IEntity;
  private destroyed: boolean;

  constructor(
    cfg: DynamicDialogConfig,
    private dialogRef: DynamicDialogRef,
    private service: EntitiesService
  ) {
    this.form = new FormGroup({
      title: new FormControl('', [Validators.required]),
    });

    if (cfg.data?.entity) {
      this.entity = cfg.data.entity;
      this.form.patchValue(this.entity);
    }
  }

  public saveChanges(): void {
    this.form.markAllAsTouched();

    Object.keys(this.form.controls).forEach((key) => {
      this.form.get(key).markAsDirty();
    });

    if (!this.form.valid) {
      return;
    }

    this.saving = true;

    this.service
      .createUpdateEntity({ id: this.entity?.id, ...this.form.value })
      .pipe(
        takeWhile(() => !this.destroyed),
        finalize(() => (this.saving = false))
      )
      .subscribe((entity) => {
        this.dialogRef.close(entity);
      });
  }

  public ngOnDestroy(): void {
    this.destroyed = true;
  }
}
